<template>
  <section class="unit-tab-section">
    <div class="section-header">
      <span class="section-eng">UNIT TYPE</span>
      <h3 class="section-title">단위세대 안내</h3>
    </div>

    <!-- 평형 탭 -->
    <div class="size-tabs">
      <button
        v-for="unit in units"
        :key="unit.id"
        class="size-tab-btn"
        :class="{ active: activeUnit === unit.id }"
        @click="activeUnit = unit.id"
      >
        {{ unit.label }}
      </button>
    </div>

    <!-- 콘텐츠 -->
    <div class="tab-content">
      <transition name="fade" mode="out-in">
        <div :key="activeUnit" class="image-container">
          <img :src="currentImage" :alt="`${activeUnit} 평면도`" class="content-image" />
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileUnitTab',
  data() {
    return {
      activeUnit: '59',
      units: [
        { id: '59', label: '59㎡' },
        { id: '74', label: '74㎡' },
        { id: '84A', label: '84㎡A' },
        { id: '84A-1', label: '84㎡A-1' },
        { id: '84B', label: '84㎡B' }
      ]
    }
  },
  computed: {
    currentImage() {
      return require(`@/assets/unit/${this.activeUnit}.jpg`)
    }
  }
}
</script>

<style scoped>
.unit-tab-section {
  width: 100%;
  background: #fff;
  padding: 50px 0 40px;
}

.section-header {
  text-align: center;
  margin-bottom: 28px;
  padding: 0 20px;
}

.section-eng {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--main-color1);
  margin-bottom: 8px;
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #222;
  letter-spacing: -0.5px;
}

/* 탭 */
.size-tabs {
  display: flex;
  justify-content: space-between;
  gap: 0;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e5e5;
  padding: 0 6px;
}

.size-tab-btn {
  flex: 1;
  min-width: 0;
  position: relative;
  padding: 14px 2px 16px;
  background: none;
  border: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #999;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.size-tab-btn::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--main-color1);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.size-tab-btn.active {
  color: var(--main-color1);
  font-weight: 700;
}

.size-tab-btn.active::after {
  transform: scaleX(1);
}

/* 콘텐츠 */
.tab-content {
  width: 100%;
}

.image-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.content-image {
  width: 100%;
  height: auto;
  display: block;
}

/* 페이드 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
